export const Days = [
  {_id: 1, name: 1},
  {_id: 2, name: 2},
  {_id: 3, name: 3},
  {_id: 4, name: 4},
  {_id: 5, name: 5},
  {_id: 6, name: 6},
  {_id: 7, name: 7},
  {_id: 8, name: 8},
  {_id: 9, name: 9},
  {_id: 10, name: 10},
  {_id: 11, name: 11},
  {_id: 12, name: 12},
  {_id: 13, name: 13},
  {_id: 14, name: 14},
  {_id: 15, name: 15},
  {_id: 16, name: 16},
  {_id: 17, name: 17},
  {_id: 18, name: 18},
  {_id: 19, name: 19},
  {_id: 20, name: 20},
  {_id: 21, name: 21},
  {_id: 22, name: 22},
  {_id: 23, name: 23},
  {_id: 24, name: 24},
  {_id: 25, name: 25},
  {_id: 26, name: 26},
  {_id: 27, name: 27},
  {_id: 28, name: 28},
  {_id: 29, name: 29},
  {_id: 30, name: 30},
  {_id: 31, name: 31},
]

export const Months = [
  {_id: 1, name: 1},
  {_id: 2, name: 2},
  {_id: 3, name: 3},
  {_id: 4, name: 4},
  {_id: 5, name: 5},
  {_id: 6, name: 6},
  {_id: 7, name: 7},
  {_id: 8, name: 8},
  {_id: 9, name: 9},
  {_id: 10, name: 10},
  {_id: 11, name: 11},
  {_id: 12, name: 12},
]

export const Years = [
  {_id: 2023, name: 2023},
  {_id: 2024, name: 2024},
  {_id: 2025, name: 2025},
  {_id: 2026, name: 2026},
]

